"use strict";
import Barba from "barba.js";
import Env from "../base/env.js";
import Grid from "../components/hotstuff/Grid";
import SlideshowCompo from "../components/moods/SlideshowCompo";
import Channels from "../base/channels";
import RegisterMail from "../components/RegisterMail";
import FlowWaypoints from "../fx/FlowWaypoints";
import Players from "../components/PlayerYT";
import GridAccordion from "../fx/Accordion";

let page;

class Page {
  constructor(view = "") {
    this.view = view;
    this.classView = "currentView--moodSingle";
    // Objects
    this.raf = undefined;
    this.compositions = [];
    this.grids = [];
    this.accordions = [];
    // Fns
    this.players = new Players(this.view);
    this.events();
    this.accordion();
    this.makeGrids();
    this.makeCompositions();
    this.bandletter = new RegisterMail(
      this.view.querySelector(".jsRegister--bandletter")
    );
    this.moodletter = new RegisterMail(
      this.view.querySelector(".jsRegister--footer")
    );
    // Launch Fn
    this.funcLaunch = this.intro.bind(this);
    if (Env.framework.UI.launcher.LAUNCHED == false) this.channels();
  }

  accordion() {
    const $items = this.view.querySelectorAll(".jsAccordion--item");
    if ($items.length) {
      for (let i = 0; i < $items.length; i++) {
        const $item = $items[i];
        let instance = new GridAccordion($item);
        instance.setup();
        this.accordions.push(instance);
      }
    }
  }

  channels() {
    Channels.on("launcher::exit", this.funcLaunch);
  }

  destroy() {
    for (let i = 0; i < this.grids.length; i++) {
      const instanceGrid = this.grids[i];
      instanceGrid.destroy();
    }
    Channels.removeListener("launcher::exit", this.funcLaunch);
    for (let j = 0; j < this.compositions.length; j++) {
      const instanceCompo = this.compositions[j];
      instanceCompo.destroy();
    }
    this.players.destroy();
    this.waypoints.destroy();
  }

  events() {
    Env.framework.UI.listenTransitionUpdateBg(this.view);

    Env.framework.UI.listenPopinTrigger(this.view);
  }

  finalize() {
    this.skinToggle();
    setTimeout(() => {
      if (Env.isVisiting === true) {
        this.intro();
      }
    }, 100);
    setTimeout(() => {
      this.waypoints = new FlowWaypoints(this.view);
    }, 200);
    setTimeout(() => {
      this.pointToAnchor();
    }, 500);
    Env.framework.UI.lazy();
    Env.framework.UI.pinRefresh();
    Env.framework.UI.lazy();
  }

  intro() {
    const tl = new TimelineLite();
    console.log(document.getElementById("jsSingle--type"));
    const $bg = this.view.querySelector(".jsBg");
    const $title = this.view.querySelector(".jsFxTitle");
    const $desc1 = this.view.querySelector(".jsFxDesc1");
    const $desc2 = this.view.querySelector(".jsFxDesc2");
    const $bar = this.view.querySelector(".jsFxBar");
    const type = document.getElementById("jsSingle--type").value;

    if (type == "moodboard") {
      tl.add([
        TweenLite.fromTo(
          $bg,
          0.8,
          { opacity: 0, y: 10 },
          { opacity: 1, y: 0, ease: Power3.easeOut }
        ),
        TweenLite.fromTo(
          $title,
          0.8,
          { opacity: 0, y: 20 },
          { opacity: 1, y: 0, ease: Power3.easeOut, delay: 0.1 }
        ),
      ]);
    } else if (type == "trendsetter") {
      tl.add([
        TweenLite.fromTo(
          $title,
          0.8,
          { opacity: 0, y: 10 },
          { opacity: 1, y: 0, ease: Power3.easeOut }
        ),
        TweenLite.fromTo(
          $desc1,
          0.8,
          { opacity: 0, y: 20 },
          { opacity: 1, y: 0, ease: Power3.easeOut, delay: 0.1 }
        ),
        TweenLite.fromTo(
          $desc2,
          0.8,
          { opacity: 0, y: 20 },
          { opacity: 1, y: 0, ease: Power3.easeOut, delay: 0.15 }
        ),
        TweenLite.fromTo(
          $bg,
          0.8,
          { opacity: 0, y: 20 },
          { opacity: 1, y: 0, ease: Power3.easeOut, delay: 0.2 }
        ),
      ]);
    } else if (type == "mymood") {
      const $bgs = this.view.querySelectorAll(".jsBg");
      tl.add([
        TweenLite.fromTo(
          $title,
          0.8,
          { opacity: 0, y: 10 },
          { opacity: 1, y: 0, ease: Power3.easeOut }
        ),
        TweenMax.staggerFromTo(
          $bgs,
          0.8,
          { opacity: 0, y: 20 },
          { opacity: 1, y: 0, ease: Power3.easeOut },
          0.05
        ),
        TweenLite.fromTo(
          $bar,
          0.8,
          { opacity: 0, y: "-45%" },
          { opacity: 1, y: "-50%", ease: Power3.easeOut, delay: 0.2 }
        ),
      ]);
    } else {
      tl.add([
        TweenLite.fromTo(
          $bg,
          0.8,
          { opacity: 0, y: 10 },
          { opacity: 1, y: 0, ease: Power3.easeOut }
        ),
        TweenLite.fromTo(
          $title,
          0.8,
          { opacity: 0, y: 20 },
          { opacity: 1, y: 0, ease: Power3.easeOut, delay: 0.1 }
        ),
      ]);
    }
  }

  makeGrids() {
    const $items = this.view.querySelectorAll(".jsIsotope--view");
    for (let i = 0; i < $items.length; i++) {
      const $item = $items[i];
      const instance = new Grid($item);
      instance.setup();
      this.grids.push(instance);
    }
  }

  makeCompositions() {
    const $items = this.view.querySelectorAll(".jsSlideshowCompo--view");

    for (let i = 0; i < $items.length; i++) {
      const $item = $items[i];
      const instance = new SlideshowCompo($item);
      instance.setup();
      this.compositions.push(instance);
    }
  }

  pointToAnchor() {
    let hash = window.location.hash;
    if (hash.length) {
      hash = hash.split("#")[1];
      const query = `p[id='${hash}']`;
      const $element = this.view.querySelector(query);
      const coords = $element.getBoundingClientRect();
      window.scrollTo(0, coords.top);
    }
  }

  skinToggle() {
    const $cover = this.view.querySelector(".jsCover");
    if ($cover != null) {
      const status = $cover.getAttribute("data-skinnav") * 1;
      if (status == 1) {
        Env.$html.classList.remove("cover--moodboard");
      } else if (
        status == 0 &&
        Env.$html.classList.contains("cover--moodboard") == false
      ) {
        Env.$html.classList.add("cover--moodboard");
      }
    }
  }
}

page = Barba.BaseView.extend({
  namespace: "moodSingle",
  node: undefined,
  onEnter: function () {
    this.node = new Page(this.container);
    Env.$html.classList.add(this.node.classView);
  },
  onEnterCompleted: function () {
    this.node.finalize();
  },
  onLeave: function () {
    this.node.destroy();
  },
  onLeaveCompleted: function () {
    if (this.container.getAttribute("data-namespace") != this.namespace) {
      Env.$html.classList.remove(this.node.classView);
    }
  },
});

export default page;
